import React from 'react';
import styles from '../LayoutDetail.module.css';

const LayoutHeader = ({ 
    layout, 
    selectedDevice, 
    onBackToList, 
    onClearSelection, 
    onEditLayout, 
    onDeleteLayout, 
    onAddDevice 
}) => {
    return (
        <div className={styles.header}>
            <div className={styles.headerLeft}>
                <button onClick={onBackToList} className={styles.backButton}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M19 12H5m0 0l7 7m-7-7l7-7"/>
                    </svg>
                    Back to Layouts
                </button>
                <div className={styles.titleSection}>
                    <h1 className={styles.title}>{layout.name}</h1>
                    <div className={styles.layoutMeta}>
                        <span className={`${styles.typeBadge} ${styles[layout.type]}`}>
                            {layout.type?.toUpperCase()}
                        </span>
                        <span className={styles.sizeInfo}>
                            {layout.size?.width} × {layout.size?.height}
                        </span>
                    </div>
                </div>
            </div>
            <div className={styles.headerActions}>
                {selectedDevice && (
                    <button 
                        className={styles.clearSelection}
                        onClick={onClearSelection}
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                        Clear Selection
                    </button>
                )}
                <button 
                    className={styles.editButton}
                    onClick={onEditLayout}
                >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                    </svg>
                    Edit Layout
                </button>
                <button 
                    className={styles.deleteButton}
                    onClick={onDeleteLayout}
                >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M3 6h18"/>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/>
                        <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                        <line x1="10" y1="11" x2="10" y2="17"/>
                        <line x1="14" y1="11" x2="14" y2="17"/>
                    </svg>
                    Delete Layout
                </button>
                <button className={styles.addDeviceButton} onClick={onAddDevice}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10"/>
                        <line x1="12" y1="8" x2="12" y2="16"/>
                        <line x1="8" y1="12" x2="16" y2="12"/>
                    </svg>
                    Add Device
                </button>
            </div>
        </div>
    );
};

export default LayoutHeader; 